<div class="w-full">
    <mat-label class="pointer-events-none cursor-default">{{label}}</mat-label>
    <div class="mt-1 rounded-md border border-gray-300 bg-card dark:bg-transparent shadow-sm overflow-hidden">
        <div class="flex items-center my-2 mx-3" [ngClass]="{'hidden': !showSearch}">
            <div class="flex items-center flex-auto min-w-0">
                <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'" class="icon-size-5"></mat-icon>
                <input #searchInput (input)="onInput($event)" (keydown)="filterValuesKeyDown($event)" [maxLength]="50"
                    class="min-w-0 ml-2 py-1 border-0" placeholder="Search..." type="text">
            </div>
        </div>
        <div class="leading-none border-t">
            <ng-template #noItems>
                <span class="flex items-center h-10 min-h-10 px-4 italic">
                    {{"no-checkbox-list-entries" | transloco}}
                </span>
            </ng-template>
            <ng-container *ngIf="filteredValues?.length; else noItems;">
                <mat-checkbox *ngIf="showCheckAll && searchInput.value.length === 0" (change)="toggleAll($event)"
                    [checked]="isEverythingChecked()" [color]="'primary'"
                    class="flex items-center h-10 min-h-10 px-4 border-b">
                    <i>{{"check-all-checkbox-label" | transloco}}</i>
                </mat-checkbox>
                <div class="max-h-40 leading-none overflow-y-auto">
                    <ng-container *ngFor="let value of filteredValues; trackBy: trackByFn">
                        <mat-checkbox (change)="toggleValue(value, $event)" [checked]="hasValue(value)"
                            [color]="'primary'" class="flex items-center h-10 min-h-10 px-4">
                            <img *ngIf="hasIcon(value)" [src]="getIcon(value)" class="object-cover w-4 inline-block">
                            {{getDisplayProperty(value)}}
                        </mat-checkbox>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>
